import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import {PhoneNumberUtil} from 'libphonenumber';
import Submission from '../models/Submission';

const fn = ($scope, $window, LocaleService, $stateParams, EventHub) => {
    const ctrl = Object.create(BaseCtrl);

    const phoneUtils = PhoneNumberUtil.getInstance();

    ctrl.init = () => {
        $scope.submission = new Submission($stateParams.quoteSummary);

        $scope.chosenQuote = _.find($scope.submission.quoteData.offeredQuotes, {
            publicID: $scope.submission.bindData.chosenQuote
        });
        $scope.chosenPlan = _.find($scope.submission.bindData.paymentPlans, {
            billingId: $scope.submission.bindData.selectedPaymentPlan
        });

        $scope.accountHolderAddress = $scope.submission.baseData.policyAddress;
        $scope.accountHolder = $scope.submission.baseData.accountHolder;
        $scope.accountHolder.contactNumber = $scope.accountHolder.homeNumber; // alternative if we need to use primary contact number this._contactNumber();
        EventHub.publish('journey', 'purchase', ctrl.createPurchaseEvent());
    };

    ctrl.createPurchaseEvent = () => {
        const submission = $scope.submission;
        const bindData = submission.bindData;
        const chosenQuote = $scope.chosenQuote;
        return {
            id: submission.quoteID,
            accountNumber: bindData.accountNumber,
            policyNumber: bindData.policyNumber,
            offering: chosenQuote.branchName,
            taxes: chosenQuote.premium.taxes,
            total: chosenQuote.premium.total,
            totalBeforeTaxes: chosenQuote.premium.totalBeforeTaxes,
            productName: submission.baseData.productName,
            paymentPlans: bindData.paymentPlans
        };
    };

    ctrl.printQuote = () => {
        $window.print();
    };

    ctrl._contactNumber = () => {
        const acctHolder = $scope.submission.baseData.accountHolder;
        const phoneType = acctHolder.primaryPhoneType;
        if (phoneType === null) {
            return;
        }

        let number;
        if (phoneType === 'work') {
            number = acctHolder.workNumber;
        } else if (phoneType === 'home') {
            number = acctHolder.homeNumber;
        } else if (phoneType === 'mobile') {
            number = acctHolder.cellNumber;
        }
        if (number === null) {
            return;
        }

        return phoneUtils.format(phoneUtils.parse(number, LocaleService.getConfiguredPhoneRegion()));
    };


    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$window', 'LocaleService', '$stateParams', 'EventHub'];
export default fn;
